export async function loadingOfGlobal<T extends keyof typeof window>(
	key: T,
	interval: number = 50
): Promise<void> {
	return new Promise<void>(resolve => {
		const isAvailable = () => window[key] !== undefined
		if (isAvailable()) {
			resolve()
		} else {
			const checkInterval = setInterval(() => {
				if (isAvailable()) {
					clearInterval(checkInterval)
					resolve()
				}
			}, interval)
		}
	})
}
